import { BaseService } from '../../../infra/base.service'
import type { PartnerPerson } from './partner-person.entity'
import type { PartnersPersonsRepository } from './partners-persons.repository'

export class PartnersPersonsService extends BaseService<PartnerPerson> {
    constructor(private rep: PartnersPersonsRepository) {
        super(rep)
    }
}
